<template>
    <div class="company-selector">
        <input
            type="search"
            class="company-selector-input"
            list="list-data"
            v-model="companySelector.resultSet.kname"
            placeholder="Company를 검색해주세요"
        />
        <!-- <button
            type="button"
            class="block p-2 text-red-500 border border-red-300 rounded hover:bg-red-100"
            @click="companySelector.getCompanyList"
        >
            search
        </button> -->
        <datalist id="list-data">
            <option
                v-for="item in companySelector.companyList"
                :value="item.kname"
                :key="item.idxCompany"
            >
                {{ item.kname }}
            </option>
        </datalist>
    </div>
</template>
<script>
import { watch, reactive, onMounted, ref } from "vue";
import axios from "@/plugins/axios.js";

export default {
    name: "BagicCompanySelector",
    components: {},
    props: ["kname"],
    setup(props, { emit }) {
        const companySelector = reactive({
            companyList: [],
            resultSet: {
                kname: "",
                idxCompany: 0,
            },

            getCompanyList() {
                //회사 목록을 조회한다.
                let searchParams = {
                    searchKeyword: companySelector.resultSet.kname,
                };
                axios
                    .get("/admin/company", {
                        params: searchParams,
                    })
                    .then(function (res) {
                        if (res.data.success) {
                            companySelector.companyList =
                                res.data.data.companyList;
                        }
                    });
            },
        });

        watch(
            () => companySelector.resultSet.kname,
            (cur, prev) => {
                let companyItem = {};
                companyItem = companySelector.companyList.filter(function (
                    item
                ) {
                    return item["kname"] === cur;
                });
                if (companyItem.length > 0) {
                    companySelector.resultSet.idxCompany =
                        companyItem[0].idxCompany;
                    //회사명이 동일한 것을 찾았다면 idx 값을 리턴해준다.
                    emit("company-click", companySelector.resultSet);
                } else {
                    companySelector.getCompanyList();
                }
            }
        );

        watch(
            () => props.kname,
            (nVal, oVal) => {
                companySelector.resultSet.kname = props.kname;
            }
        );

        onMounted(() => {
            companySelector.resultSet.kname = props.kname;
        });

        return {
            companySelector,
        };
    },
};
</script>
<style scoped>
.company-selector {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
}

.company-selector-input {
    height: 2.875rem;
    width: 100%;
    min-width: 0;
    max-width: 28rem;
    border: 1px solid #cbd5e1;
    border-radius: 0.75rem;
    background: #fff;
    padding: 0.7rem 0.9rem;
    font-size: 0.95rem;
    color: #0f172a;
    outline: none;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
}

.company-selector-input:focus {
    border-color: #94a3b8;
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}
</style>
